import { combineReducers } from 'redux'
import user from './userReducer'
import entries from './entryReducer'
import folders from './folderReducer'
import news from './newsReducer'
import videos from './videosReducer'
import diet from './dietReducer'

const rootReducer = combineReducers({
  user,
  folders,
  news,
  videos,
  diet,
})

export default rootReducer
